import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCListDataModule } from '@wlp/ui-c-list-data';
import { UiCListDebitsDetranComponentModule } from '@wlp/ui-c-list-debits-detran';
import { UiCConsultDetranModule } from '@wlp/ui-c-consult-detran';
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { UiBsCashInModule } from "@wlp/ui-bs-cashin";
import { UiBsDetranModule } from "@wlp/ui-bs-detran";
import { UiBsTranslateModule } from "@wlp/ui-bs-translate";
import { UiCAccountBalanceModule } from "@wlp/ui-c-account-balance";
import { UiCPaymentExtractModule } from "@wlp/ui-c-payment-extract";
import { UiCPaymentResumeModule } from "@wlp/ui-c-payment-resume";
import { TooltipModule } from "ng2-tooltip-directive";
import { InterceptService } from "src/app/core/intercept/intercept.service";
import { ComponentsModule } from "src/app/core/shared/modules/components.module";
import { environment } from "src/environments/environment";
import { ConsultComponent } from "./consult/consult.component";
import { DetranRoutingModule } from "./detran-routing.module";
import { PaymentResumeDetran } from "./payment-resume/payment-resume.component";
import { UiCTextValueModule } from '@wlp/ui-c-text-value';
import { UiCPaymentReceiptModule } from '@wlp/ui-c-payment-receipt';
import { ReceiptDetranPage } from './receipt-detran/detran-receipt.page';
import { UiCPdfGeneratorModule } from '@wlp/ui-c-pdf-generator';
import { DetranPage } from './detran.page';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';
import { UiCSelectTypePaymentModule } from '@wlp/ui-c-select-type-payment';
import { CarListComponent } from './car-list/car-list.component';
import { UiCListCarDetranModule } from '@wlp/ui-c-car-list-detran';
import { UiCRegisterCarDetranModule } from '@wlp/ui-c-register-car-detran';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TooltipModule,
    ComponentsModule,
    ReactiveFormsModule,
    UiCAccountBalanceModule,
    UiBsCashInModule.forRoot({ device: 'WEB', config: environment }),
    DetranRoutingModule,
    UiCPaymentResumeModule,
    UiCPaymentExtractModule,
    UiBsTranslateModule.forRoot({ device: 'WEB', config: environment }),
    UiBsDetranModule,
    UiCConsultDetranModule,
    UiCListDebitsDetranComponentModule,
    UiCListDataModule,
    UiCTextValueModule,
    UiCPaymentReceiptModule,
    UiCButtonModule,
    UiCPdfGeneratorModule,
    HeaderUserInfoModule,
    UiCSelectTypePaymentModule,
    UiCListCarDetranModule,
    UiCRegisterCarDetranModule
  ],
  declarations: [
    ConsultComponent,
    DetranPage,    
    PaymentResumeDetran,
    ReceiptDetranPage,
    CarListComponent
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ]
})
export class DetranModule { }
